import { Pipe, PipeTransform } from '@angular/core';

/**
 * A hint, never a validation error, when a VAT number does not look like one: not a country code
 * followed by digits, or a Belgian number that fails its mod-97 check. The number is accepted as
 * typed and stored compact and uppercase.
 */
@Pipe({
	name: 'vatNumberHint'
})
export class VatNumberHintPipe implements PipeTransform {
	transform(vatNumber: string | null): string | null {
		const compact = String(vatNumber ?? '').replace(/[^A-Za-z0-9]/g, '').toUpperCase();
		if (!compact) {
			return null;
		}
		const hint = 'Belgisch BTW-nummer: BE0123456789';
		const match = compact.match(/^([A-Z]{2})(\d+)$/);
		if (!match) {
			return hint;
		}
		const [, country, digits] = match;
		if (country === 'BE' && !VatNumberHintPipe.validBelgianNumber(digits)) {
			return hint;
		}
		return null;
	}

	static validBelgianNumber(digits: string): boolean {
		return digits.length === 10 && 97 - (Number(digits.slice(0, 8)) % 97) === Number(digits.slice(8));
	}
}
